/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { SELECT_MESSAGE } from '../constants/rhybus-config'
import InputLabel from './input-label'

interface Props {
  'aria-label'?: any
  badge?: any
  badgecount?: any
  className?: any
  disabled?: any
  error?: any
  extras?: any
  extrasClassName?: any
  formClassName?: any
  icon?: any
  id?: any
  info?: any
  infoClassName?: any
  infoIcon?: any
  inline?: any
  inputProps?: any
  isInfo?: any
  isMandatory?: any
  label?: any
  name?: any
  onChange?: any
  onClick?: any
  props?: any
  readonly?: any
  style?: any
  type?: any
}
const InputSelect = (inputProps: Props) => {
  return (
    <div className={inputProps?.formClassName}>
      {inputProps?.label && (
        <InputLabel
          className={inputProps?.inputProps?.className}
          extras={inputProps?.extras}
          extrasClassName={inputProps.extrasClassName}
          infoLabel={inputProps?.info}
          isinfoClassName={inputProps?.infoClassName}
          isinfoIcon={inputProps?.infoIcon}
          isinfoLabel={inputProps?.isInfo}
          label={inputProps?.label}
          labelProps={{ htmlFor: inputProps?.inputProps?.id }}
          mandatory={inputProps?.isMandatory}
          onClick={inputProps?.onClick}
        />
      )}
      <select
        aria-label={inputProps['aria-label'] || inputProps?.label}
        aria-readonly={inputProps?.readonly}
        aria-required={inputProps?.isMandatory}
        className={inputProps?.className}
        disabled={inputProps?.disabled}
        id={inputProps?.inputProps?.id}
        name={inputProps?.inputProps?.name}
        onChange={inputProps?.onChange}
        placeholder={inputProps?.inputProps?.placeholder}
        size={inputProps?.inputProps?.size || 'sm'}
        style={inputProps?.style}
        value={inputProps?.inputProps?.value}
      >
        {inputProps?.defaultSelect && <option value=''>Select</option>}
        {inputProps?.defaultAll && <option value=''>All</option>}
        {inputProps?.options && inputProps?.options.length > 0
          ? inputProps?.options.map(
            (item: any) => (
              (<option key={item} value={item}>{item}</option>)
            )
          )
          : null
        }
      </select>
      {inputProps?.error && (
        <p className='errormsg'>
          {SELECT_MESSAGE} {inputProps?.label || inputProps['aria-label']}
        </p>
      )}
    </div>
  )
}
export default InputSelect
